// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { previousSaturday as fn } from "../previousSaturday.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const previousSaturday = convertToFP(fn, 1);

// Fallback for modularized imports:
export default previousSaturday;
